module.exports = __webpack_public_path__ + "static/img/008.142d0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand/008.png
// module id = RP7D
// module chunks = 1